export const ECLAT_MINIMALISTE_HERO_FALLBACK =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCo7I09iiAjA30crFmjaJncauLsg2kecwsiWxgGk56mZyp9ThVds5Tmx4x4hMGU2tIE9Jjocli_vbRPPQNbqtBm3HKm8XcX1SmAfnmv01sOxdDOfCPX733rhTbkOB5sPRGc5zJOq1LEigU0ZUqjoSNXBJB4gjKHLv5uOvKrtsuC61V44rZPBL8Lz5oz8Hhz26kUUa3_KgQzpkyyDrYq21Pbvc0pTG5pS1PQTirBSpvpg23uvhPPAsi1YsUHnHdSL3LD5rYJtKx1oao";

export const BLISS_EDITORIAL_HERO_FALLBACK =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCvS8q4nRxdBxBEEu09Z1JZbcAZ45rORYtElL0mqvTLmfr8xStp3KoVvA4lbJaORWcr6P2MUiazQnNDgyiDrs97gZGGIucQ4B2eLDKwuxFCyRrZlA66crt9H_lq2JCQokM4NfZQWSSev9bIxK4lswrS-MKQYTxYbPUISchIsCYZAz019bVT8dj5AD7q4cj6tGZe9FovuOSr_AdnXSU-V2E1e0EQYIRWSrr6rQoF62-yxWDSE9qphFyXvuQr6ftwSN0Q7ViL6_Lwcto";

export const DRESS_CODE_MOODBOARD_FALLBACK =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCTWnVHCUYo1AZugO1dOth0EkB_mME_pKIdTBGmK5MmqrDB3sDKEOxfMDhKKG75yV31vk99jhAuptXhDyEcu_PEJAAnsEBeV1xLsTxj-FD2MXTbzwzUv3lNq0airjbhlwUEB8zNcqZPXVDGe0mFC86l7i3fZp-CxYylwhhO7y2rvS_405ffBqlzGBHn9OY93HTi2zOAK7NzIEQK4XHbsbs3wOiVsaRNTz3DZVDSNCpPOWAjMK5DhFNUbgJP4EZR8Mc-zmTmQc_ZiSE";

// All Nature Romantique defaults are repository assets. Keeping this mapping
// in one place prevents a template fallback from silently pointing elsewhere.
export const NATURE_ROMANTIQUE_ASSETS = Object.freeze({
  hero: "/images/theme-assets/asset_36b06323.png",
  story: "/images/theme-assets/asset_492e322e.png",
  venue: "/images/theme-assets/asset_41558ba0.png",
  gallery: [
    "/images/theme-assets/asset_3869274b.png",
    "/images/theme-assets/asset_7170f474.png",
    "/images/theme-assets/asset_0a2d4b52.png",
    "/images/theme-assets/asset_129afec5.png"
  ]
});
